module.exports = __webpack_public_path__ + "static/media/plan_list.45739973.png";